//LIBRERIES
import { computed, createApp, defineComponent, onMounted, reactive, Ref, ref, toRefs } from 'vue'
import {  i18n } from '../lang/index';
import moment from "../node_modules/moment/moment";
import { useI18n } from 'vue-i18n';

//MODELS
import { App } from "../domain/App";
import { Cookie } from "../domain/Cookie";
import { Languages } from "../domain/enum/Languages";
import { Constants } from "../domain/enum/Constants";
import { CookiesType } from "../domain/enum/CookiesType";
import ICommonDataState from '../domain/interfaces/ICommonDataState';

//APISERVICES
import { getHeaderConfiguration, getClientAvailableLanguajes, getFeatureFlag } from "../infrastructure/apiServices/masterData.service";

//COMPOSABLES
import { useCommonData } from "./composables/useCommonData";
import { useIncidences } from "./composables/useIncidences";

export const SharedGeneralComponent = defineComponent({
  setup() {
    // dependencies
    const { t, locale } = useI18n();
    // states
    const commonDataState = reactive({
      headerConfig: {
        title: null,
        image: null,
        favicon: {
          title: '',
          image: null,
        },
        host: '',
        name: '',
        emailSender: '',
        clientId: '',
        cif: '',
        email: '',
        urlElectronicHeadquarters: null,
        dpoEmail: '',
        address: '',
        phoneNumber: 0,
        replacementListsVisible: false,
        hasRegistryApi: false,
        hasOnlinePayment: false,
        hasPasarelaPayment: false,
        backgroundColor: '',
        textColor: '',
        security: {
          twoFactorMandatory: false,
          verificationCodeExpirationTimeInMinutes: 0,
          timeRequest2FAAgainInDays: 0,
        },
    },
      availableLanguajes: { defaultLanguage: '', secondLanguage: ''},
      cookie: new Cookie(),
      app: new App(),
      locale
    });
    // computed properties
    const currentLanguage = computed(() => commonDataState.locale);
    const lastLogin = computed(() => moment(commonDataState.app.profile.lastLogin[0]).format(commonDataState.app.formatDate) + ' ' + moment.utc(commonDataState.app.profile.lastLogin[0]).local().format('HH:mm:ss'));
    const timeRequest2FAAgainInDays = computed(() => {
      return commonDataState.headerConfig.security.timeRequest2FAAgainInDays > 1 ?
        commonDataState.headerConfig.security.timeRequest2FAAgainInDays + ' ' + t('lang.cookies.days')
        : commonDataState.headerConfig.security.timeRequest2FAAgainInDays + ' ' + t('lang.cookies.day');
    });

    // shared properties
    const isLoading = ref(false);
    const showMandatoryCookies = ref(false);
    const showAnalysisCookies = ref(false);
    const showModalConfigurateCookies = ref(false);
    const showServiceStopModal = ref(false);
    const dontShowAgainStopServiceModalAgain = ref(false);
    const serviceStopLocalStorageKey = 'dontShowServiceStopModal';
    const serviceStopEndDate = moment('2025-02-19T18:30:00');

    // methods
    const changeLocal = (language: string) => {
      commonDataState.locale = language;
      commonDataState.app.changeLanguaje(language);
    };

    const saveCookies = () => {
      commonDataState.cookie.savePersonalizateCookies();
      showModalConfigurateCookies.value = false;
    };

    const closeModalConfigurateCookies = () => {
      showModalConfigurateCookies.value = false;
      showMandatoryCookies.value = false;
      showAnalysisCookies.value = false;
    };

    const acceptAllCookies = () => {
      commonDataState.cookie.acceptAllCookies();
    };
    
    const declineAllCookies = () => {
      commonDataState.cookie.declineAllCookies();
    };

    const getAllData = () => {
      commonDataState.app.getProfile();
    };

    const updateCommonData = (state: ICommonDataState) => {
      commonDataState.availableLanguajes = state.availableLanguajes;
      commonDataState.cookie = state.cookie;
      commonDataState.headerConfig = state.headerConfig;
      commonDataState.app = state.app;
      commonDataState.locale = state.locale;

      getAllData();
    };

    // composables
    const useCommonDataDependencies = {
      updateCommonData,
      getHeaderConfiguration,
      getFeatureFlag,
      getClientAvailableLanguajes,
    };
    const { loadCommonData } = useCommonData(useCommonDataDependencies);
    const { incidence, showNotificationIncidence, IncidencesTypes, closeIncidence} = useIncidences();

    // lifecycle hooks
    onMounted(() => {
      loadCommonData();
      showServiceStopModal.value = commonDataState.app.isServiceStopActive && (!localStorage.getItem(serviceStopLocalStorageKey));
    });

    return {
      // dependencies
      t,
      Languages: Languages,
      constants: Constants,
      euskara: Constants.language.EU_ES,
      cookiesType: CookiesType,
      // states
      ...toRefs(commonDataState),
      // shared view properties
      showServiceStopModal,
      showModalConfigurateCookies,
      dontShowAgainStopServiceModalAgain,
      serviceStopEndDate,
      showMandatoryCookies,
      showAnalysisCookies,
      // computed properties
      lastLogin,
      pageTitle: '',
      currentLanguage,
      timeRequest2FAAgainInDays,
      // methods
      getAllData,
      saveCookies,
      closeModalConfigurateCookies,
      acceptAllCookies,
      declineAllCookies,
      changeLocal,
      closeIncidence,
      // view properties
      isLoading,
      incidence,
      showNotificationIncidence,
      IncidencesTypes
    }
  }
});
const vueApp = createApp(SharedGeneralComponent);
vueApp.use(i18n);
vueApp.config.compilerOptions.whitespace = 'preserve';
vueApp.mount(Constants.APP);